import { render, staticRenderFns } from "./InternetTradingPolicyPopUp.vue?vue&type=template&id=b8c00486&scoped=true&lang=pug"
import script from "./InternetTradingPolicyPopUp.vue?vue&type=script&lang=ts"
export * from "./InternetTradingPolicyPopUp.vue?vue&type=script&lang=ts"
import style0 from "./InternetTradingPolicyPopUp.vue?vue&type=style&index=0&id=b8c00486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c00486",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LsPopupSaveChangesResponse: require('/workspace/portal/hosting/components/_base/Popup/PopupSaveChangesResponse.vue').default,InternetTradingPolicyDetailsPopUp: require('/workspace/portal/hosting/components/InternetTradingPolicyDetailsPopUp.vue').default})
